export const STATUS_AKTIF = 11
export const STATUS_NONAKTIF = 12
export const STATUS_PENDING = 13
export const STATUS_REJECT = 14
export const STATUS_BLOKIR = 15
export const JADWAL_REGULER = 1
export const KONVERSI_JAM = [
  'batas_jam_datang_akhir',
  'batas_jam_datang_mulai',
  'batas_jam_pulang_akhir',
  'batas_jam_pulang_mulai',
  'jam_datang',
  'jam_istirahat_mulai',
  'jam_istirahat_selesai',
  'jam_pulang',
  'jam_toleransi_datang',
  'jam_toleransi_pulang',
  'batas_awal_jam_istirahat_mulai',
  'batas_awal_jam_istirahat_selesai',
  'batas_akhir_jam_istirahat_mulai',
  'batas_akhir_jam_istirahat_selesai',
]

export default {
  STATUS_AKTIF,
  STATUS_NONAKTIF,
  STATUS_PENDING,
  STATUS_REJECT,
  STATUS_BLOKIR,
  JADWAL_REGULER,
  KONVERSI_JAM,
}
